<template>
<div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-dids'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Dids</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-dids'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addDid">Add DID</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
        <span class="container-title">Add DID</span>
        <div class="col-wrapper">
          <div class="col">
            <primary-input type="number"
                           name="did"
                           class="field"
                           v-model="did.did"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('did')}"
                           placeholder="Enter did number" />
            <div class="help is-danger"
                 v-if="errors.has('did')">
              {{ errors.first('did') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.did ? didError.did[0] : null}}
            </div>
            <primary-select type="text"
                            name="company"
                            v-validate="'required'"
                            v-model="did.company_uuid"
                            :class="{'input': true, 'is-danger': errors.has('company')}"
                            placeholder="Company">
                <option :value="i.company_uuid"
                    v-for="(i, company_uuid) in comapnies"                    
                    :key="company_uuid">{{i.company_name}}
                </option>
            </primary-select>
             <div class="help is-danger"
                 v-if="errors.has('company')">
              {{ errors.first('company') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.company ? didError.company[0] : null}}
            </div>
            
          </div>
          <div class="col"> 
              <primary-select type="text"
                            name="type"
                            v-validate="'required'"
                            v-model="did.type"
                            :class="{'input': true, 'is-danger': errors.has('type')}"
                            placeholder="Type">
                <option :value="i"
                    v-for="(i, type) in type"                    
                    :key="type">{{i}}
                </option>
            </primary-select>
            <div class="help is-danger"
                 v-if="errors.has('type')">
              {{ errors.first('type') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.type ? didError.type[0] : null}}
            </div>
            <primary-select type="text"
                            name="did type"
                            v-validate="'required'"
                            v-model="did.did_type"
                            :class="{'input': true, 'is-danger': errors.has('did type')}"
                            placeholder="Type">
                <option :value="i"
                    v-for="(i, type) in didType"                    
                    :key="type">{{i}}
                </option>
            </primary-select>
            <div class="help is-danger"
                 v-if="errors.has('did type')">
              {{ errors.first('did type') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.did_type ? didError.did_type[0] : null}}
            </div>
          </div>
          <!-- <div class="col">
            <primary-input type="text"
                           name="last name"
                           v-model="did.last_name"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('first name')}"
                           placeholder="Enter last name" />
            <div v-if="errors.has('last name')"
                 class="help is-danger">
              {{ errors.first('last name') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.last_name ? didError.last_name[0] : null}}
            </div>
            <primary-input name="email"
                           type="text"
                           v-model="did.email"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('first name')}"
                           placeholder="elyse_sauer@yahoo.com" />
            <div v-if="errors.has('email')"
                 class="help is-danger">
              {{ errors.first('email') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.email ? didError.email[0] : null}}
            </div>
            <primary-input type="password"
                           name="re-enter password"
                           v-validate="'required|confirmed:password'"
                           data-vv-as="password"
                           v-model="checkPassowrd"
                           :class="{'input': true, 'is-danger': errors.has('first name')}"
                           placeholder="********" />
            <div class="help is-danger"
                 v-if="errors.has('re-enter password')">
              {{ errors.first('re-enter password') }}
            </div>
            <div class="help is-danger"
                 v-if="didError">
              {{didError.passwd ? didError.passwd[0] : null}}
            </div>
          </div> -->
        </div>
    </div>
</div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
  },
  data: () => ({
    didError: null,
    type: ['Virtual', 'Landline', 'Mobile', 'Toll Free'],
    didType: ['ANI', 'DNIS'],
    did: {
      did: null,
      company_uuid: null,
      did_type: null,
      type: null,
    },
    countrys: [],
    comapnies: [],
  }),
  async created() {
    this.getCountryList();
    await this.getCompanyList();
  },
  methods: {
    getCountryList() {
        this.$store.dispatch("getCountryList", {
            nice_name: ''
        }).then((res) => {
            this.countrys = res.items
        })
    },
    async getCompanyList() {
        let { total } = await this.$store.dispatch("GetCompanyList", {})
        const res = await this.$store.dispatch("GetCompanyList", { perPage: total})
        this.comapnies = res.items;
    },
    addDid() {      
      this.$validator.validate().then(result => {
        if (result) {
          console.log("this.did", this.did);
          this.$store
            .dispatch("AddDid", {
              did: this.did
            })
            .then(() => {
              this.$snotify.success("DID have been added.", {
                timeout: 6000
              });
                this.$router.push({ name: "reseller-dids" });
            })
            .catch(err => {
              if (err.errors) {
                this.didError = err.errors[0].did
                  ? err.errors[0].did
                  : null;
                setTimeout(() => {
                  this.didError = null;
                }, 6000);
              } else {
                this.$snotify.error(err.response.data.errors, {
                  timeout: 6000
                });
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container{
    font-family: "Helvetica Neue";
    padding: 0 20px;
    .add-navigation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        .back-link {
        cursor: pointer;
        display: flex;
        align-items: center;
        fill: #51a3f3;
        color: #51a3f3;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        p {
          margin-bottom: 0;
        }
        }
        .buttons-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .primary-button {
            height: 40px;
            width: 110px;
        }
        .secondary-button {
            height: 40px;
            width: 90px;
            margin-right: 20px;
          }
        }
    }
    .add-container {
        flex-direction: column;
        align-items: center;
        height: 375px;
        background-color: #FFFFFF;
        padding-left: 15px;
        padding-top: 15px;
        .container-title {
            height: 30px;	
            width: 432px;	
            color: #000000;		
            font-size: 18px;	
            font-weight: 500;	
            line-height: 30px;
            padding: 15px 0 15px 0;
        }
        .col-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            .col {
                width: 100%;
                margin-right: 15px;
                padding: 0;
                .input {
                    margin-bottom: 20px;
                }
                .field {
                  p.pimary-input-title {
                    color: #000000;
                    font-family: ""Helvetica Neue"";
                    font-size: 12px;
                    font-weight: 300;
                  }
                }
                .pimary-input-title {
                    color: #000000;
                    font-family: ""Helvetica Neue"";
                    font-size: 12px;
                    font-weight: 300;
                    letter-spacing: 0.21px;
                    line-height: 15px;
                    margin-bottom: 5px;
                    text-transform: uppercase;
                }
            }
        }
    }
}


    
</style>

